import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { BlankLayout } from "@/layouts";
import { Button } from "@/ui/button";

export const BlankView = ({
    actionBtnData,
    description,
    hasActionBtn,
    hasDescription,
    hasTitle,
    otherData,
    title,
} : {
    actionBtnData?: {
        hasLink?: boolean,
        linkRouteUrl?: string,
        linkText?: string,
        onClick?: () => void,
        text?: string
    },
    description?: string,
    hasActionBtn?: boolean,
    hasDescription?: boolean,
    hasTitle?: boolean,
    otherData?: ReactNode,
    title?: string
}) => (
    <BlankLayout>
        <div className="flex h-screen flex-col items-center justify-center gap-3 md:gap-6">
            <div className="flex flex-col items-center justify-center gap-3">
                {hasTitle && <h4 className="text-xl font-bold text-foreground md:text-3xl">{title}</h4>}
                {hasDescription && <p className="text-sm font-semibold text-foreground md:text-lg">{description}</p>}
                {otherData}
            </div>
            {hasActionBtn && (
                <Button onClick={() => (actionBtnData?.onClick ? actionBtnData.onClick() : null)}>
                    {actionBtnData?.hasLink && actionBtnData.linkRouteUrl ? <Link to={actionBtnData.linkRouteUrl}>{actionBtnData.linkText}</Link> : actionBtnData?.text}
                </Button>
            )}
        </div>
    </BlankLayout>
);
